import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { KeyEventUtil } from 'utils'

const FechaVencimientoFormGroup = ({ iTouched, iError, fIsSubmitting }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('input-dias', e)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='FEC VENC.' htmlFor='input-fechaVencimiento' md={12} />
      <Col md={12}>
        <Field name='fechaVencimiento'>
          {({ field }) => (
            <Form.InputDate {...field} id='input-fechaVencimiento' isInvalid={iTouched && iError} disabled={fIsSubmitting} onKeyDown={onKeyDown} />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaVencimientoFormGroup)
